import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("video", component(opts));
  editor.BlockManager.add("video", block(opts));
};